import { useCommentsConfig } from "@/react/components/CommentsCompass/Provider/ConfigContext";
import { useIsOrCanBeCommunityMember } from "@/react/contexts/punditUserContext";

export interface EngagementActionsVisibility {
  canShowLikeAction: boolean;
  canShowReplyAction: boolean;
}

export const useEngagementActionsVisibility =
  (): EngagementActionsVisibility => {
    const { isLikingEnabled, isReplyingEnabled } = useCommentsConfig();
    const isOrCanBeCommunityMember = useIsOrCanBeCommunityMember();

    return {
      canShowLikeAction: isLikingEnabled && isOrCanBeCommunityMember,
      canShowReplyAction: isReplyingEnabled && isOrCanBeCommunityMember,
    };
  };
